"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderItemRefundStatus',
  props: {
    payNum: [Number, String],
    refundNum: [Number, String],
    itemStatus: Object,
    showFulfillment: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    productName: String,
    sku: String
  },
  computed: {
    snapshot: function snapshot() {
      return this.itemStatus || {};
    },
    refundProgressVisible: function refundProgressVisible() {
      return this.snapshot.refundProgressVisible !== false || this.snapshot.refundState !== 'NONE';
    },
    showReturnSummary: function showReturnSummary() {
      return !['不涉及退货', '无需退回', '无需退货', '无需物流'].includes(this.snapshot.returnText);
    },
    refundText: function refundText() {
      if (this.snapshot.refundText) return this.snapshot.refundText;
      var purchased = Number(this.payNum);
      var refunded = Number(this.refundNum);
      if (Number.isSafeInteger(purchased) && purchased > 0 && Number.isSafeInteger(refunded) && refunded > 0) {
        return '退款完成' + refunded + '/' + purchased + '件';
      }
      return '退款进度待核实';
    },
    refundTone: function refundTone() {
      var state = this.snapshot.refundState;
      if (state === 'COMPLETE' || state === 'PARTIAL') return 'is-completed';
      if (state === 'PENDING') return 'is-pending';
      return state === 'NONE' ? 'is-none' : 'is-unknown';
    },
    moneyText: function moneyText() {
      if (this.snapshot.refundedAmount == null) return '';
      var amount = Number(this.snapshot.refundedAmount);
      return Number.isFinite(amount) && amount >= 0 ? '现金￥' + amount.toFixed(2) : '';
    }
  }
};